import { useCallback, useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

const useIsShiftPressed = (enabled = true) => {
  const [pressed, setPressed] = useState(false);

  const cancelPressed = useCallback(() => setPressed(false), []);

  useHotkeys(
    '*',
    (event: KeyboardEvent) => {
      if (event.key === 'Shift') {
        if (event.type === 'keydown') {
          setPressed(true);
        } else if (event.type === 'keyup') {
          setPressed(false);
        }
      }
    },
    {
      keydown: true,
      keyup: true,
      enabled,
    },
  );

  // Cancel pressed when browser loses focus, e.g. it is minimzed
  useEffect(() => {
    if (!enabled) {
      setPressed(false);
      return;
    }

    window.addEventListener('blur', cancelPressed);
    return () => {
      window.removeEventListener('blur', cancelPressed);
    };
  }, [cancelPressed, enabled]);

  return pressed;
};

export default useIsShiftPressed;
